import { ActionIcon, Alert, Badge, Box, Button, Grid, Group, Loader, Modal, Paper, Text, Title, UnstyledButton, useMantineTheme } from "@mantine/core";
import { notifications } from "@mantine/notifications";
import React, { useState } from "react";
import { FaCartPlus, FaPhone } from "react-icons/fa";
import { useApp } from "../../contexts/app.context";
import { useAuth } from "../../contexts/auth.context";
import { useLanguage } from "../../contexts/language.context";
import { DELETE_PHONE, GET_ALL_PHONES, GET_AVAILABLE_PHONES, SAVE_PHONE, VERIFY_TELNYX_PHONE } from "../../services/phones";
import { countriesList } from "../../utility/util";
import InputField, { InputFieldTypes } from "../input_field";

export default function Phones() {
    const [data, setData] = useState<any[]>([]);
    const [loadingSave, setLoadingSave] = useState<boolean>(false);
    const [loadingPhones, setLoadingPhones] = useState<boolean>(false);
    const [loadingRegions, setLoadingRegions] = useState<boolean>(true);
    const [newPhone, setNewPhone] = useState<any>(null);
    const [verificationCode, setVerificationCode] = useState<any>({});
    // const [regions, setRegions] = useState<any[]>(['US']);
    const [regions, setRegions] = useState<any[]>([
        "US"
    ]);
    const [availablePhones, setAvailablePhones] = useState<{ [key: string]: any[] }>({});

    const { confirmDialog } = useApp();
    const { userData } = useAuth();
    const { str } = useLanguage();
    const theme = useMantineTheme();

    const loadPhones = () => {
        GET_ALL_PHONES()
            .then((res) => {
                setData(res)
            })
            .catch(err => {
                notifications.show({ title: "Ops.", message: err.message, color: 'red' })
            })
    }

    const loadAvailablePhones = () => {
        if (newPhone?.countryCode) {
            setAvailablePhones(ap => ({ ...ap, [newPhone?.countryCode ?? '']: [] }));
            setLoadingPhones(true);
            GET_AVAILABLE_PHONES({ countryCode: newPhone?.countryCode, areaCode: newPhone?.areaCode })
                .then(({ twilio = [], telnyx = [], regions: avlRegions = [] }) => {
                    setLoadingPhones(false);
                    setLoadingRegions(false);
                    setRegions(avlRegions);
                    setAvailablePhones(ap => ({
                        ...ap, [newPhone?.countryCode ?? '']:
                            [
                                ...twilio.map((item: any) => ({
                                    ...item,
                                    origin: "twilio",
                                    phoneNumber: item.phoneNumber,
                                    friendlyName: item.friendlyName,
                                })),
                                ...telnyx.map((item: any) => ({
                                    ...item,
                                    origin: "telnyx",
                                    phoneNumber: item.phoneNumber,
                                    friendlyName: item.friendlyName
                                }))
                            ]
                    }));
                })
                .catch(err => {
                    setLoadingPhones(false);
                    notifications.show({ title: "Ops.", message: err.message, color: 'red' })
                })
        }
    }

    const handleSave = () => {
        setLoadingSave(true)
        SAVE_PHONE({ ...newPhone })
            .then((res) => {
                setLoadingSave(false)
                loadPhones()
                setNewPhone(null);
                notifications.show({ message: str("PHONES.CONNECTED"), color: 'green' })
            })
            .catch(err => {
                setLoadingSave(false)
                notifications.show({ title: "Ops.", message: err.message, color: 'red' })
            })
    }

    React.useEffect(() => { loadPhones() }, [])
    React.useEffect(() => { loadAvailablePhones() }, [newPhone?.countryCode, newPhone?.areaCode])

    return <>
        <Paper p="md">
            <Group>
                <FaPhone />
                <Title c="gray.0" style={{ flex: 1 }} order={5}>{str("PHONES.TITLE")}</Title>
                <Button
                    leftSection={<FaCartPlus />}
                    onClick={() => { setNewPhone({ type: "new", countryCode: "US" }) }}
                >{str("PHONES.BUY")}</Button>
            </Group>
        </Paper>

        <Grid mt="md">
            {data.map((phone: any) => (
                <Grid.Col span={{ base: 12, md: 6 }}>
                    {/* <UnstyledButton style={{width: '100%'}} onClick={() => { setSelectedKnowledgeCategory(phone)}}> */}
                    <Paper p="md" shadow="xs" style={{ backgroundColor: theme.colors.dark[8] }}>
                        <Group mb="xs">
                            {phone.type !== "sip" && <ActionIcon
                                size="lg"
                                color={
                                    (
                                        ["success", "in-use"].includes(phone?.data?.twilio?.status) ||
                                        phone?.data?.telnyx?.status
                                    )
                                        ? "green" : undefined}
                                onClick={() => {
                                    if (!["success", "in-use"].includes(phone?.data?.twilio?.status)) {
                                        if (phone.type === "host" && phone.origin !== "telnyx") {
                                            confirmDialog({ text: str("PHONES.RESEND_VERIFICATION") }, ({ confirmed }) => {
                                                if (confirmed) {
                                                    SAVE_PHONE(phone)
                                                        .then((res) => {
                                                            loadPhones()
                                                            notifications.show({ message: str("PHONES.CONNECTED"), color: 'green' })
                                                        })
                                                        .catch(err => {
                                                            notifications.show({ title: "Ops.", message: err.message, color: 'red' })
                                                        })
                                                }
                                            })
                                        }
                                    }
                                }}
                            ><FaPhone /></ActionIcon>}
                            <Box style={{ flex: 1 }}>
                                <Text c="gray.0" ta="center" fw="bold" size="sm">{phone.number}</Text>
                                {
                                    phone?.data?.twilio_verification?.validationCode &&
                                    !["success", "in-use"].includes(phone?.data?.twilio?.status) &&
                                    <Text c="gray.0" ta="center" size="md" mt="md">{str("PHONES.VALIDATION_CODE")}: {phone?.data?.twilio_verification?.validationCode}</Text>}
                            </Box>
                        </Group>
                        {!phone?.data?.telnyx?.status && phone.type === "host" && phone.origin === "telnyx" &&
                            (
                                phone?.data?.telnyx?.error
                                    ? <Group mb="md">
                                        <Text c="gray.0" style={{ flex: 1 }} pr="xl"></Text>
                                        <Button
                                            size="md"
                                            onClick={() => {
                                                SAVE_PHONE(phone)
                                                    .then((res) => {
                                                        loadPhones()
                                                    })
                                                    .catch(err => {
                                                        notifications.show({ title: "Ops.", message: err.message, color: 'red' })
                                                    })
                                            }}
                                        >Resend Code</Button>
                                    </Group>
                                    : <Group mb="md">
                                        <InputField
                                            name="code"
                                            style={{ flex: 1, border: '1px solid #CACACA', borderRadius: 4 }}
                                            placeholder="Type the verification code"
                                            value={verificationCode[phone.id]}
                                            onChange={({ code }) => setVerificationCode((vc: any) => ({ ...vc, [phone.id]: code }))}
                                        />
                                        <Button
                                            size="md"
                                            disabled={(verificationCode[phone.id] ?? "").length < 5}
                                            onClick={() => {
                                                VERIFY_TELNYX_PHONE(phone.id, verificationCode[phone.id])
                                                    .then(() => {
                                                        loadPhones();
                                                        notifications.show({ message: "Phone verified", color: "green" });
                                                    })
                                                    .catch(err => {
                                                        loadPhones();
                                                        notifications.show({ message: err.message, color: "red" });
                                                    })
                                            }}
                                        >Verify</Button>
                                    </Group>
                            )
                        }
                        <Group justify="flex-end">
                            <UnstyledButton>
                                <Badge
                                    size="xs"
                                    variant="outline"
                                    color="gray"
                                    onClick={() => {
                                        confirmDialog({ text: str("PHONES.DELETE_CONFIRM") }, ({ confirmed }) => {
                                            if (confirmed) {
                                                DELETE_PHONE(phone.id)
                                                    .then(() => {
                                                        loadPhones();
                                                        notifications.show({ message: str("PHONES.DELETED"), color: "green" });
                                                    })
                                                    .catch(err => {
                                                        notifications.show({ message: err.message, color: "red" });
                                                    })
                                            }
                                        })
                                    }}
                                >Remove</Badge>
                            </UnstyledButton>
                        </Group>
                    </Paper>
                    {/* </UnstyledButton> */}
                </Grid.Col>
            ))}
        </Grid>

        <Modal
            opened={!!newPhone}
            onClose={() => setNewPhone(null)}
        >
            {!userData?.user?.whitelabelAdmin && (
                (newPhone?.type === "new" && userData?.plan?.phone_connect_price) ||
                (newPhone?.type === "host" && userData?.plan?.phone_host_price)
            ) ? <Alert color="yellow" mb="md">
                <Text c="gray.0" size="md" ta="center" mb="md">{
                    ({
                        new: str("PHONES.BUY_TITLE"),
                        host: str("PHONES.BUY_HOST_TITLE"),
                    }[newPhone?.type as string] ?? "")
                        .replace(/\$/g, `${userData?.plan?.currency ?? "USD"} `)
                        .replace(/2/g, userData?.plan?.phone_host_price ?? 2)
                        .replace(/10/g, userData?.plan?.phone_connect_price ?? 10)
                }</Text>
            </Alert> : null}

            <InputField
                mb="md"
                name="type"
                fieldType={InputFieldTypes.SELECT}
                clearable={false}
                searchable={false}
                value={newPhone?.type ?? "new"}
                onChange={({ type }) => setNewPhone((np: any) => ({ ...np, type }))}
                options={[
                    { label: str("PHONES.NEW_PHONE"), value: "new" },
                    { label: str("PHONES.HOST_PHONE"), value: "host" },
                    { label: str("PHONES.SIP_PHONE"), value: "sip" },
                ]}
            />

            {newPhone?.type === "host" && <Text c="gray.0" ta="center" mt="md" mb="md">{str("PHONES.HOST_DESCRIPTION")}</Text>}

            {newPhone?.type === "new" && newPhone?.countryCode === 'US' && <InputField
                title={str("AREA_CODE")}
                mb="md"
                name="areaCode"
                fieldType={InputFieldTypes.NUMBER}
                value={newPhone?.areaCode}
                autoComplete="off"
                onChange={({ areaCode }) => setNewPhone((np: any) => ({ ...np, areaCode }))}
            />}
            {newPhone?.type === "new" && <InputField
                title={str("COUNTRY")}
                mb="md"
                name="countryCode"
                fieldType={InputFieldTypes.SELECT}
                value={newPhone?.countryCode}
                autoComplete="off"
                leftSection={loadingRegions && <Loader size="xs" color="white" />}
                onChange={({ countryCode }) => setNewPhone((np: any) => ({ ...np, countryCode }))}
                nothingFound="No country code found"
                options={countriesList.filter(c => regions.includes(c.value))}
            />}

            {
                newPhone?.type === "sip"
                    ? <>
                        <InputField
                            title={str("PHONE_NUMBER")}
                            mb="md"
                            name="number"
                            value={newPhone?.number}
                            onChange={({ number }) => setNewPhone((np: any) => ({ ...np, number }))}
                        />
                        <InputField
                            title={str("PHONES.HOST")}
                            mb="md"
                            name="host"
                            value={newPhone?.data?.host}
                            onChange={({ host }) => setNewPhone((np: any) => ({ ...np, data: { ...np?.data, host } }))}
                        />
                        <InputField
                            title={str("PHONES.PORT")}
                            mb="md"
                            name="port"
                            value={newPhone?.data?.port}
                            onChange={({ port }) => setNewPhone((np: any) => ({ ...np, data: { ...np?.data, port } }))}
                        />
                        <InputField
                            title={str("PHONES.EXTENSION")}
                            mb="md"
                            name="extension"
                            value={newPhone?.data?.extension}
                            onChange={({ extension }) => setNewPhone((np: any) => ({ ...np, data: { ...np?.data, extension } }))}
                        />
                        <InputField
                            title={str("PHONES.PASSWORD")}
                            mb="md"
                            name="password"
                            value={newPhone?.data?.password}
                            onChange={({ password }) => setNewPhone((np: any) => ({ ...np, data: { ...np?.data, password } }))}
                        />
                    </>
                    : <InputField
                        title={str("PHONE_NUMBER")}
                        mb="md"
                        name="number"
                        autoComplete="off"
                        disabled={newPhone?.type !== "host" && !newPhone?.countryCode}
                        fieldType={newPhone?.type === "host" ? undefined : InputFieldTypes.SELECT}
                        value={newPhone?.number}
                        leftSection={loadingPhones && <Loader size="xs" color="white" />}
                        onChange={({ number }) => setNewPhone((np: any) => ({
                            ...np,
                            ...(availablePhones[newPhone?.countryCode ?? ''] ?? []).find(ap => ap.phoneNumber === number),
                            number,
                        }))}
                        nothingFound="No phone number available"
                        options={(availablePhones[newPhone?.countryCode ?? ''] ?? []).map(ap => ({ value: ap.phoneNumber, label: ap.friendlyName }))}
                    />
            }

            <Group justify="flex-end">
                <Button loading={loadingSave} onClick={handleSave}>{
                    userData?.user?.whitelabelAdmin
                        ? str("SAVE")
                        : str("PHONES.ORDER")
                }</Button>
            </Group>
        </Modal>
    </>
}
